import {
	GET_FAILURES_PACKET,
	GET_FAILURE_PACKET_DETAILS,
	TOGGLE_PACKET_EDIT_FAILURE_DIALOG,
	SET_FORM_STATE
} from '../actions/PacketActions';

const initialState = {
	failures: [],
	packetEditFailureDialogVisibility: false,
	formState: {
		values: {
			failureSource: 'fail',
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const packetReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_FAILURES_PACKET: {
						return {
							...state,
							failures: action.failures
						};
					}
					case GET_FAILURE_PACKET_DETAILS: {
						return {
							...state,
							failure: action.failure,
							formState: {
								...state.formState,
								values: { ...action.failure.trackerPacketDetailsDto }
							}
						};
					}
					case TOGGLE_PACKET_EDIT_FAILURE_DIALOG: {
						return {
							...state,
							packetEditFailureDialogVisibility: action.visible,
							tableId: action.tableId
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					default: {
						return state;
					}
	}
};

export default packetReducer;
